import { ResourceStore } from 'src/stores/ResourceStore/ResourceStore';

export const ProductOfferingTypeResourceStore = new ResourceStore(
    'data/offeringTypes.json',
);
